import { NullOrMissingField1bkks6typ2v8h as NullOrMissingField } from '../exception/Exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function missingField(jsonReader, name) {
  throw NullOrMissingField().new_com_apollographql_apollo_exception_NullOrMissingField_iji73y_k$("Field '" + name + "' is missing or null at path " + toString(jsonReader.getPath_18su3p_k$()));
}
//region block: exports
export {
  missingField as missingField4n9ldh7pi82p,
};
//endregion

//# sourceMappingURL=Assertions.mjs.map
